import { createFileRoute } from "@tanstack/react-router"
import { AssignmentStatus, AssignmentsPage } from "@/assignment"
import type { Uuid } from "@/utils"

type AssignmentsSearch = {
  status?: AssignmentStatus
  briefId?: Uuid
  page?: number
}

export const Route = createFileRoute("/(user)/t/$tenantSlug/assignments")({
  validateSearch: (search): AssignmentsSearch => ({
    status: Object.values(AssignmentStatus).includes(
      search.status as AssignmentStatus,
    )
      ? (search.status as AssignmentStatus)
      : undefined,
    briefId: typeof search.briefId === "string" ? search.briefId : undefined,
    page:
      typeof search.page === "number" && search.page > 1
        ? search.page
        : undefined,
  }),
  component: RouteComponent,
})

function RouteComponent() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <AssignmentsPage
      search={search}
      onSearchChange={(partial) => {
        void navigate({ search: (prev) => ({ ...prev, ...partial }) })
      }}
    />
  )
}
